import SMConst from 'lib/SMConst';

class SMPaymentSelectHelper {
  static isCard(paymentSelect) {
    return paymentSelect == SMConst.PaymentSelect.Card;
  }

  static isBank(paymentSelect) {
  	return paymentSelect == SMConst.PaymentSelect.Bank;
  }

  static isPostpay(paymentSelect) {
    return paymentSelect == SMConst.PaymentSelect.Postpay;
  }

  static isBusinessAccount(paymentSelect) {
    return paymentSelect == SMConst.PaymentSelect.BusinessAccount;
  }
}
export default SMPaymentSelectHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMPaymentSelectHelper.js